import {IUsuario} from "../../entities/catalogos/IUsuario";

export const SET_USUARIO = "SET_USUARIO";

interface ISetUsuario {
    type: typeof SET_USUARIO
    usuario: IUsuario
}

export type UsuarioActionTypes = ISetUsuario
